// extracted by mini-css-extract-plugin
export default {"container":"Header_container__xcCIW","title":"Header_title__6LykN","row":"Header_row__dqBJp","danger":"Header_danger__o0e7Q","success":"Header_success__BUik-"};